import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

// swiper
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

// swiper
SwiperCore.use([Navigation, Pagination, Autoplay]);


const SlideCard = styled.div`
  width: 100%;
  margin-top: -70px;
  .swiper-button-next, .swiper-button-prev{
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.1);
    &:after{
      color: #FFFDFA;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .swiper-button-next{
    right: 300px;
  }
  .swiper-button-prev{
    left: 300px;
  }
  .swiper-pagination-bullet{
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active{
    background: #FFFDFA;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    .swiper-button-next{
      right: 50px;
    }
    .swiper-button-prev{
      left: 50px;
    }
    .swiper-button-next, .swiper-button-prev{
      width: 34px;
      height: 34px;
    }
  `}
`

const SwiperItem = styled.div`
  width:100%;
  text-align: center;
`

export default function SlideElement() {
  const bannerList = [
    {
      imgPath: '/images/homeNew/banner_base.png',
      isWeb: false,
      linkPath: 'https://bakeryswap.medium.com/build-bakeryswap-on-base-4416b1552094'
    },
    {
      imgPath: '/images/homeNew/banner_ai.png',
      isWeb: false,
      linkPath: 'https://www.bakeai.world/'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_kxa.jpg',
      isWeb: true,
      linkPath: '/bakery/KXA/BAKE'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_piazze.jpg',
      isWeb: true,
      linkPath: '/drops/piazze'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/kryptomon.jpg',
      isWeb: true,
      linkPath: '/collection/Kryptomon'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_lnkciar.jpg',
      isWeb: true,
      linkPath: '/drops/lnkciar'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_swog.jpg',
      isWeb: true,
      linkPath: '/drops/swog'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_nt.jpg',
      isWeb: true,
      linkPath: '/bakery/NT/BAKE'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner-monday.jpg',
      isWeb: true,
      linkPath: '/stakenft/BMONCNFTSTAKE/GENESIS%20NFT'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_halloween.jpg',
      isWeb: true,
      linkPath: '/drops/halloween'
    },
    {
      index: 1,
      imgPath: '/images/homeNew/banner-allen.png',
      isWeb: false,
      linkPath: 'https://gallery.bakeryswap.org/drops/anniversary'
    },
    {
      index: 1,
      imgPath: '/images/homeNew/banner_asap.png',
      isWeb: false,
      linkPath: 'https://gallery.bakeryswap.org/drops/asap'
    },
    {
      index: 2,
      imgPath: '/images/homeNew/banner_binamon2.jpg',
      isWeb: true,
      linkPath: '/drops/binamons'
    },
    {
      index: 3,
      imgPath: '/images/homeNew/banner_hiphop2.jpg',
      isWeb: false,
      linkPath: 'https://gallery.bakeryswap.org/mysteryBox'
    },
    {
      imgPath: '/images/homeNew/banner_gallery.jpg',
      isWeb: false,
      linkPath: 'https://gallery.bakeryswap.org/'
    }
  ]

  return (
    <SlideCard>
      <Swiper
          style={{width: '100%'}}
          spaceBetween={50} 
          slidesPerView={1}
          autoplay={{delay: 4000}}
          pagination={{ clickable: true }}
          centeredSlides
          loop
          navigation
          observer={true}
          observeParents={true}
          onResize={(swiper) => {swiper.update();}}
        >
          {
            bannerList.map((d, i) => {
              return (
                <SwiperSlide key={i}>
                  <SwiperItem>
                    {
                      d.isWeb ?
                      <NavLink to={d.linkPath} >
                        <img src={d.imgPath} width={'100%'} alt=""/>
                      </NavLink>
                      : <a href={d.linkPath} target="_blank" rel="noopener noreferrer">
                        <img src={d.imgPath} width={'100%'} alt=""/>
                      </a>
                    }
                  </SwiperItem>
                </SwiperSlide>
              )
            })
          }
      </Swiper>
    </SlideCard>
  )
}
